import { FC } from "react";

import { Trans } from "@lingui/react/macro";

import styled from "@mui/material/styles/styled";
import Typography, { TypographyProps } from "@mui/material/Typography/";

import Button from "@readai/common/components/Button";

import ROUTES from "@app/booking/routes";

export const EventNotificationTitle = styled<FC<TypographyProps>>((props) => (
  <Typography variant="h2" {...props} />
))(({ theme }) => ({
  color: theme.palette.shades.neutral[80],
  fontWeight: 500,
}));

export const EventNotificationAction = styled(Button)({
  width: "fit-content",
});

export const EventNotificationDescription = styled<FC<TypographyProps>>(
  (props) => <Typography variant="bodyPrimaryReg" {...props} />,
)(({ theme }) => ({
  color: theme.palette.shades.neutral[800],
}));

export const ReturnToRead = () => (
  <EventNotificationAction href={ROUTES.MAIN_APP.LANDING_PAGE}>
    <Trans>Return to Read</Trans>
  </EventNotificationAction>
);
